// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1BX5P","bigColWidth":"Table_bigColWidth__2sIKS","biggerColWidth":"Table_biggerColWidth__1l7Lf","row":"Table_row__Wr1wC","col":"Table_col__s7psq"};